module.exports = __webpack_public_path__ + "static/img/pay.08e753a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay.png
// module id = 321P
// module chunks = 2